import type { VariantProps } from "cva";
import { cva } from "cva";
import {
  type HeadingProps,
  Heading as RACHeading,
} from "react-aria-components";
import { twMerge } from "tailwind-merge";

const styles = cva({
  base: "text-theme-on-background transition-[color] duration-200",
  variants: {
    level: {
      1: ["text-base", "font-medium"],
      2: ["text-base", "font-medium"],
      3: ["text-base", "font-medium"],
      4: ["text-base", "font-medium"],
      5: ["text-base", "font-medium"],
      6: ["text-base", "font-medium"],
    },
  },
});

type Props = HeadingProps & VariantProps<typeof styles>;

export function Heading({ children, level = 1, className, ...rest }: Props) {
  return (
    <RACHeading
      className={twMerge(styles({ level }), className)}
      {...rest}
      level={level}
    >
      {children}
    </RACHeading>
  );
}
